.text-center {
  flex-grow: 1;
  text-align: center;
}

.biel-bot-wrapper {
  position: absolute;
  z-index: var(--biel-bot-wrapper-z-index);
}

.biel-bot-wrapper--embedded {
  position: relative;
}

.biel-overlay {
  background-color: var(--biel-bot-screenshot-bg-color);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: var(--biel-bot-screnshot-z-index);
}

.biel-bot {
  display: inline-block;
  position: relative;
}

.biel-bot-content {
  background-color: var(--biel-bot-content-bg-color);
  border: 1px solid var(--biel-bot-content-border-color);
  border-radius: var(--biel-bot-content-border-radius);
  box-shadow: var(--biel-bot-content-box-shadow);
  box-sizing: border-box;
  color: var(--biel-bot-content-text-color);
  display: flex;
  flex-direction: column;
  font-family: var(--biel-bot-content-font-family);
  left: 50%;
  max-width: 90%;
  height: 70vh;
  max-height: 70vh;
  overflow: hidden;
  padding: 20px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: var(--biel-bot-content-z-index);
  transition: all 0.3s ease-in-out;
  animation: fadeIn 0.3s;
}

.biel-bot-wrapper--embedded .biel-bot-content {
  height: auto;
  position: relative;
  top: initial;
  left: initial;
  transform: none;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  border: 0;
  box-shadow: none;
  border-radius: 0;
}

.biel-bot-header {
  margin-bottom: 20px;
  flex-shrink: 0;
}

.biel-bot-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.biel-bot-body biel-input {
  flex-shrink: 0;
}

.biel-bot-body biel-chat {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.biel-bot-footer {
  font-size: var(--biel-footer-font-size);
  text-align: center;
  flex-shrink: 0;
}

.biel-bot-footer a {
  color: var(--biel-bot-footer-link);
  font-weight: 500;
  text-decoration: none;
}

.biel-logo {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.biel-logo a {
  margin-left: 3px;
}

.biel-bot-close {
  background-color: var(--biel-bot-close-bg-color);
  border: 0;
  border-radius: 50%;
  cursor: pointer;
  height: 22px;
  margin-left: auto;
  padding: 0;
  width: 22px;
}

.biel-bot-close svg {
  stroke: var(--biel-bot-close-color);
}

.biel-bot-content.fullscreen {
  width: 100vw;
  max-width: 100vw;
  height: 100%;
  max-height: 100%;
  border-radius: 0;
  padding: 20px 5vw;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s ease-in-out;
  animation: fadeIn 0.3s;
}

@media screen and (min-width: 768px) {

  .biel-bot-content {
    max-width: var(--biel-bot-content-max-width);
    height: 70vh;
    max-height: 70vh;
  }

  .biel-bot-content.biel-bot-content--bottom-right {
    bottom: var(--biel-bot-content-position-bottom);
    left: initial;
    right: var(--biel-bot-content-position-right);
    top: initial;
    transform: initial;
  }

  .biel-bot-content.biel-bot-content--bottom-left {
    bottom: var(--biel-bot-content-position-bottom);
    left: var(--biel-bot-content-position-left);
    top: initial;
    transform: initial;
  }

  .biel-bot-content.biel-bot-content--top-right {
    right: var(--biel-bot-content-position-right);
    left: initial;
    top: var(--biel-bot-content-position-top);
    transform: initial;
  }

  .biel-bot-content.biel-bot-content--top-left {
    left: var(--biel-bot-content-position-left);
    top: var(--biel-bot-content-position-top);
    transform: initial;
  }

  .biel-bot-content.biel-bot-content--center-left {
    left: 5px;
    right: auto;
    top: 50%;
    transform: translateY(-50%);
  }

  .biel-bot-content.biel-bot-content--center-right {
    left: auto;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);
  }

  .biel-bot-content.biel-bot-content--top-center {
    left: 50%;
    right: auto;
    top: var(--biel-search-content-position-top-center);
    transform: translateX(-50%);
  }

  .biel-bot-content.biel-bot-content--sidebar-left.biel-bot-content--open,
  .biel-bot-content.biel-bot-content--sidebar-right.biel-bot-content--open {
    transform: translateX(0);
    max-height: 100vh;
  }

  .biel-bot-content.biel-bot-content--sidebar-left {
    max-width: 450px;
    left: 0;
    right: auto;
    height: 100vh;
    top: 0;
    transform: translateX(-100%);
    border-radius: 0;
  }

  .biel-bot-content.biel-bot-content--sidebar-right {
    max-width: 450px;
    left: auto;
    right: 0;
    height: 100vh;
    top: 0;
    transform: translateX(100%);
    border-radius: 0;
  }

  .biel-bot-content.fullscreen {
    width: 100vw;
    max-width: 100vw;
    height: 100vh;
    max-height: 100vh;
    border-radius: 0;
    padding: 20px 25vw;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    transition: all 0.3s ease-in-out;
    animation: fadeIn 0.3s;
  }

  .biel-bot-content.fullscreen.biel-bot-content--bottom-right {
    left: initial;
    top: initial;
    bottom: 0;
    right: 0;
    transform: initial;
  }

  .biel-bot-content.fullscreen.biel-bot-content--bottom-left {
    left: 0;
    top: initial;
    bottom: 0;
    transform: initial;
  }

  .biel-bot-content.fullscreen.biel-bot-content--center-right,
  .biel-bot-content.fullscreen.biel-bot-content--top-right {
    left: initial;
    top: 0;
    bottom: 0;
    right: 0;
    transform: initial;
  }

  .biel-bot-content.fullscreen.biel-bot-content--sidebar-right {
    left: initial;
    top: 0;
    bottom: 0;
    right: 0;
    transform: initial;
  }

  .biel-bot-content.fullscreen.biel-bot-content--sidebar-left {
    left: 0;
    top: 0;
    bottom: 0;
    transform: initial;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}